<article class="promo-block" [ngClass]="getClasses()">
  <figure *ngIf="widget.data.image">
    <div class="promo-block--image">
      <app-webp-image [src]="getImageUrl()" [alt]="widget.data.title"></app-webp-image>
    </div>
  </figure>

  <h4>{{widget.data.title}}</h4>
  <p class="text-small" [innerHtml]="widget.data.text|safe"></p>

  <div class="promo-block-button" *ngIf="widget.data.buttonText && widget.data.buttonLink">
    <a *ngIf="isExternalLink()" class="button" [href]="widget.data.buttonLink">
      {{widget.data.buttonText}}
    </a>
    <a *ngIf="!isExternalLink()" class="button" [routerLink]="widget.data.buttonLink">
      {{widget.data.buttonText}}
    </a>
  </div>
</article>
